import {
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  isToday as isDateToday,
  startOfMonth,
  startOfWeek,
} from "date-fns";

/**
 * Lay month grid days out Sunday → Saturday.
 * API may return Monday-first order; we remap by date and fill the Sunday-based grid.
 */
export function alignCalendarWeekToSunday(days, monthDate) {
  const byDate = new Map((days ?? []).map((day) => [day.date, day]));
  const monthStart = startOfMonth(monthDate);
  const monthEnd = endOfMonth(monthDate);
  const gridStart = startOfWeek(monthStart, { weekStartsOn: 0 });
  const gridEnd = endOfWeek(monthEnd, { weekStartsOn: 0 });
  const monthKey = format(monthDate, "yyyy-MM");

  return eachDayOfInterval({ start: gridStart, end: gridEnd }).map((date) => {
    const dateStr = format(date, "yyyy-MM-dd");
    const existing = byDate.get(dateStr);

    if (existing) {
      return existing;
    }

    return {
      date: dateStr,
      isToday: isDateToday(date),
      isSelected: isDateToday(date),
      isCurrentMonth: format(date, "yyyy-MM") === monthKey,
      events: [],
    };
  });
}
